import { AbstractPmsApiService } from "./abstract.service";
import { GeneralSettings } from "../models";

/**
 * @class GeneralSettingsPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GeneralSettings>}
 */
export class GeneralSettingsPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/general-settings';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {GeneralSettings}
     * @protected
     */
    newModel(attributes, ...params) {

        return new GeneralSettings(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<Property>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {GeneralSettings} generalSettings
     * @returns {Promise.<Property>}
     */
    save(property, generalSettings) {

        const url = this.url({propertyId: property.id});

        return this.http
                .post(url, generalSettings, {
                    headers: this.authHeaders
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/general-settings.service.js